import { Edit2, Trash2, Power, PowerOff, Loader2 } from "lucide-react";

export function CategoriesTable({
  categories,
  selectedCategories,
  allSelected,
  onSelectAll,
  onSelectCategory,
  onEdit,
  onToggleStatus,
  onDelete,
  loadingStatus = {},
  loadingDelete = {},
}) {
  return (
    <div className="bg-white dark:bg-[#1E1E1E] border border-[#E5E7EB] dark:border-[#2A2A2A] rounded-xl overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-[#F9FAFB] dark:bg-[#1A1A1A] border-b border-[#E5E7EB] dark:border-[#2A2A2A]">
            <tr>
              <th className="px-4 py-3 text-left">
                <input
                  type="checkbox"
                  checked={allSelected}
                  onChange={(e) => onSelectAll(e.target.checked)}
                  className="w-4 h-4 rounded border-[#E5E7EB] dark:border-[#2A2A2A] text-[#62397f] focus:ring-[#62397f] cursor-pointer"
                />
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-[#666666] dark:text-[#A0A0A0] uppercase tracking-wider font-inter">
                Image
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-[#666666] dark:text-[#A0A0A0] uppercase tracking-wider font-inter">
                Category Name
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-[#666666] dark:text-[#A0A0A0] uppercase tracking-wider font-inter">
                Unit Measurement
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-[#666666] dark:text-[#A0A0A0] uppercase tracking-wider font-inter">
                Products
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-[#666666] dark:text-[#A0A0A0] uppercase tracking-wider font-inter">
                Status
              </th>
              <th className="px-4 py-3 text-right text-xs font-semibold text-[#666666] dark:text-[#A0A0A0] uppercase tracking-wider font-inter">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#E5E7EB] dark:divide-[#2A2A2A]">
            {categories.map((category) => {
              const isDeleting = loadingDelete[category.id];
              const isToggling = loadingStatus[category.id];
              return (
                <tr
                  key={category.id}
                  className="hover:bg-[#F9FAFB] dark:hover:bg-[#1A1A1A] transition-colors"
                >
                  <td className="px-4 py-4">
                    <input
                      type="checkbox"
                      checked={selectedCategories.includes(category.id)}
                      onChange={(e) =>
                        onSelectCategory(category.id, e.target.checked)
                      }
                      className="w-4 h-4 rounded border-[#E5E7EB] dark:border-[#2A2A2A] text-[#62397f] focus:ring-[#62397f] cursor-pointer"
                    />
                  </td>
                  <td className="px-4 py-4">
                    <img
                      src={category.image}
                      alt={category.name}
                      className="w-12 h-12 rounded-lg object-cover border border-[#E5E7EB] dark:border-[#2A2A2A]"
                    />
                  </td>
                  <td className="px-4 py-4">
                    <span className="font-semibold text-sm text-[#111111] dark:text-white font-inter">
                      {category.name}
                    </span>
                  </td>
                  <td className="px-4 py-4">
                    <span className="text-sm text-[#666666] dark:text-[#A0A0A0] font-inter">
                      {category.unitMeasurement}
                    </span>
                  </td>
                  <td className="px-4 py-4">
                    <span className="inline-flex items-center justify-center px-3 py-1 bg-[#F5F3FF] dark:bg-[#2A2440] text-[#62397f] dark:text-[#A78BFA] text-sm font-semibold rounded-full font-poppins">
                      {category.productsCount}
                    </span>
                  </td>
                  <td className="px-4 py-4">
                    {isToggling ? (
                      <div className="flex items-center justify-center">
                        <Loader2 className="animate-spin w-4 h-4 text-gray-500" />
                      </div>
                    ) : category.status === "active" ? (
                      <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 text-green-600 dark:text-green-400 text-xs font-medium rounded-full">
                        <div className="w-1.5 h-1.5 bg-green-500 rounded-full"></div>
                        Active
                      </span>
                    ) : (
                      <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-gray-50 dark:bg-gray-900/20 border border-gray-200 dark:border-gray-800 text-gray-600 dark:text-gray-400 text-xs font-medium rounded-full">
                        <div className="w-1.5 h-1.5 bg-gray-500 rounded-full"></div>
                        Disabled
                      </span>
                    )}
                  </td>
                  <td className="px-4 py-4">
                    <div className="flex items-center justify-end gap-2">
                      <button
                        onClick={() => onEdit(category)}
                        className="p-2 rounded-lg text-[#666666] dark:text-[#A0A0A0] hover:bg-[#F9FAFB] dark:hover:bg-[#262626] hover:text-[#62397f] dark:hover:text-[#A78BFA] transition-all"
                        title="Edit"
                        disabled={isDeleting || isToggling}
                      >
                        <Edit2 size={16} />
                      </button>
                      <button
                        onClick={() => onToggleStatus(category.id)}
                        className={`p-2 rounded-lg transition-all ${category.status === "active"
                            ? "text-[#666666] dark:text-[#A0A0A0] hover:bg-[#F9FAFB] dark:hover:bg-[#262626] hover:text-orange-500"
                            : "text-[#666666] dark:text-[#A0A0A0] hover:bg-[#F9FAFB] dark:hover:bg-[#262626] hover:text-green-500"
                          }`}
                        title={
                          category.status === "active" ? "Disable" : "Activate"
                        }
                        disabled={isDeleting || isToggling}
                      >
                        {category.status === "active" ? (
                          <PowerOff size={16} />
                        ) : (
                          <Power size={16} />
                        )}
                      </button>
                      <button
                        onClick={() => onDelete(category)}
                        className="p-2 rounded-lg text-[#666666] dark:text-[#A0A0A0] hover:bg-red-50 dark:hover:bg-red-900/20 hover:text-red-600 dark:hover:text-red-400 transition-all"
                        title="Delete"
                        disabled={isDeleting || isToggling}
                      >
                        {isDeleting ? (
                          <Loader2 className="animate-spin w-4 h-4 text-red-500" />
                        ) : (
                          <Trash2 size={16} />
                        )}
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
